import React, { useCallback, useEffect, useMemo, useReducer, useState } from 'react'
import { Grid } from '@mui/material'
import { HomeHeader } from '../../shared/organism/AdminToolHeader'
import getColumnsForManualExecution from './getManualRemovalColumns'
import DataTable from '../../shared/molecule/DataTable'
import {
  BrokerRecordsSelector,
} from '../../../redux/brokerService'
import brokerRecordReducer, { initialState } from './brokerRecordReducer'
import Loader from '@meprism/shared/src/components/atoms/Loader'
import {useAppDispatch} from '../../../redux/storeExports';
import {getParentsBrokerList} from '../../../redux/brokerService'
import FilterContainer from '../../shared/molecule/FilterContainer'
import { formatBrokerNames } from '../../../utils/helpers'
import useBrokerRecordsFetch from '../../../utils/hooks/useBrokerRecordsFetch'

const ManualRemovals: React.FC = () => {
  const dispatch = useAppDispatch()

  const [brokerOptions, setBrokerOptions] = useState<{title: string; id: string}[]>([])

  useEffect(() => {
    const fetchBrokers = async () => {
      try {
        const response = await dispatch(getParentsBrokerList())
        const brokers: string[] = response.payload.brokers || []
        const formatted = brokers.map(broker => ({
          title: broker,
          id: broker,
        }))
        setBrokerOptions(formatted)
      } catch (error) {
        console.error('Failed to fetch brokers:', error)
      }
    }
    fetchBrokers()
  }, [dispatch])

  const [brokerRecordsReqParams, dispatchBrokerRecordsReqParams] = useReducer(
    brokerRecordReducer,
    {
      ...initialState,
      filters: {
        ...initialState.filters,
        brokerNames: formatBrokerNames(brokerOptions.map(b => b.id)), // use fetched brokers
      },
    },
  )

  const { isFetching, fetchResults } = useBrokerRecordsFetch(
    brokerRecordsReqParams,
  )
  const { records, hasNext } = BrokerRecordsSelector()

  const handlePaginationChange = useCallback(
    (key: 'page' | 'pageSize', value: number) => {
      dispatchBrokerRecordsReqParams({
        type: 'UPDATE_PAGINATION',
        payload: { key, value },
      })
    },
    [dispatchBrokerRecordsReqParams],
  )

  const handleSortChange = useCallback(
    (property: string) => {
      dispatchBrokerRecordsReqParams({
        type: 'UPDATE_SORTERS',
        payload: { property },
      })
    },
    [dispatchBrokerRecordsReqParams],
  )

  const columns = useMemo(
    () =>
      getColumnsForManualExecution(
        brokerRecordsReqParams.sort.order,
        handleSortChange,
      ),
    [brokerRecordsReqParams.sort.order, handleSortChange],
  )

  return (
    <>
      <HomeHeader allBrokers />
      <FilterContainer
        handleRefetch={fetchResults}
        dataBrokerOptions={brokerOptions}
        brokerRecordsReqParams={brokerRecordsReqParams}
        dispatchBrokerRecordsReqParams={dispatchBrokerRecordsReqParams}
        disableBroker={false}
        shouldDisplayRecordType={true}
      />
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center">
        <Loader loading={isFetching}>
          <Grid xs={12} md={12}>
            <DataTable
              columns={columns}
              rows={records}
              rowType="manual-removal"
              onPageChange={(page: number) =>
                handlePaginationChange('page', page)
              }
              onPageSizeChange={(pageSize: number) =>
                handlePaginationChange('pageSize', pageSize)
              }
              hasNext={hasNext}
              pageSize={brokerRecordsReqParams.pageSize}
              page={brokerRecordsReqParams.page}
              handleSort={handleSortChange}
            />
          </Grid>
        </Loader>
      </Grid>
    </>
  )
}

export default ManualRemovals
